import React, { Component } from "react"
import PropTypes from "prop-types"
import Activate from "components/views/activate/Activate"
import CardStates from "utils/CardStates"
import { connect } from "react-redux"
import { activateCard } from "actions"
import { withRouter } from "react-router-dom"
import {
  getCardState,
  getIsActivateError,
  getIsActivateSubmitting,
  getEmployeeId,
  getHasCardholderId,
  getIsCarrotCardEligible
} from "reducers/userInfo"
import { reportErrorMessage } from "../../../utils/ErrorReporting"

class ActivateContainer extends Component {
  componentDidMount() {
    if (this.props.isCCEligible) {
      if (this.props.cardState === CardStates.ACTIVE || this.props.cardState === CardStates.LOCKED) {
        this.props.history.push("/reimbursements/activate/done")
      } else if (this.props.cardState === CardStates.ELIGIBLE && !this.props.hasCardholderId) {
        this.props.history.push("/transactions")
      } else if (this.props.cardState === CardStates.SHIPPED || this.props.cardState === CardStates.ELIGIBLE) {
        this.props.history.push("/reimbursements/activate")
      } else {
        if (this.props.cardState === CardStates.INELIGIBLE) {
          reportErrorMessage(
            `Member with employee ID: ${this.props.employeeId} has card state of ${this.props.cardState} but their company has Carrot Card.`
          )
        }
        this.props.history.push("/transactions")
      }
    } else if (!this.props.isCCEligible) {
      if (this.props.cardState !== CardStates.INELIGIBLE) {
        reportErrorMessage(
          `Member with employee ID: ${this.props.employeeId} has card state of ${this.props.cardState} but their company doesn't have Carrot Card.`
        )
      }
      this.props.history.push("/transactions")
    }
  }

  componentDidUpdate(nextProps) {
    if (this.props.cardState !== nextProps.cardState) {
      if (this.props.cardState === CardStates.ACTIVE) {
        this.props.history.push("/reimbursements/activate/success")
      }
    }
  }

  handleSubmit = async (e) => {
    e.preventDefault()
    this.props.activateCard(this.props.employeeId)
  }

  render() {
    return (
      <Activate
        error={this.props.isActivateError}
        onSubmit={this.handleSubmit}
        submitting={this.props.isActivateSubmitting}
      />
    )
  }
}

ActivateContainer.propTypes = {
  isActivateSubmitting: PropTypes.bool.isRequired,
  isActivateError: PropTypes.bool.isRequired,
  cardState: PropTypes.string,
  employeeId: PropTypes.number.isRequired,
  history: PropTypes.object.isRequired,
  isCCEligible: PropTypes.bool,
  hasCardholderId: PropTypes.bool,
  activateCard: PropTypes.func
}

const mapStateToProps = (state) => ({
  isActivateSubmitting: getIsActivateSubmitting(state),
  isActivateError: getIsActivateError(state),
  cardState: getCardState(state),
  employeeId: getEmployeeId(state),
  isCCEligible: getIsCarrotCardEligible(state),
  hasCardholderId: getHasCardholderId(state)
})

ActivateContainer = connect(mapStateToProps, { activateCard })(ActivateContainer)
// exported to unit test without withRouter
export { ActivateContainer }

export default withRouter(ActivateContainer)
